import { AccountLoginResult } from "models/ApiEnums";
import i18next from "i18next";

export class AuthHelpers {

    static translateStatus(status: AccountLoginResult): string {
        return i18next.t(`Common.AccountLoginResult.${AccountLoginResult[status]}`)
    }
}